'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _reactRedux = require('react-redux');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// popover for when user hovers over the medal icons
// and it shows us a description of it
var popoverHoverFocus = function popoverHoverFocus(paramID, paramTitle, paramStrong, paramText) {
  return _react2.default.createElement(
    ReactBootstrap.Popover,
    { id: paramID, title: paramTitle },
    _react2.default.createElement(
      'strong',
      null,
      paramStrong
    ),
    ' ',
    paramText
  );
};

var Medals = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user, app: state.moduleData.data };
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Medals, _Component);

  function Medals() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Medals);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Medals.__proto__ || (0, _getPrototypeOf2.default)(Medals)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      medals: [{
        hover: 'hover0',
        title: 'Getting started',
        boldText: 'Awesome!',
        description: 'Congratulations on your first step into Reboot Kids!'
      }, {
        hover: 'hover1',
        title: 'Healthy eating habits',
        boldText: 'Keep eating greens.',
        description: 'Healthy eating habits are important.'
      }, {
        hover: 'hover2',
        title: 'Home food environment',
        boldText: 'Follow the HELPS guide!',
        description: 'Maintain positive meal times.'
      }, {
        hover: 'hover3',
        title: 'Encouraging vegetables',
        boldText: 'The P\'s and C\'s framework.',
        description: 'Remembering mealtime strategies.'
      }, {
        hover: 'hover4',
        title: 'Review and future planning',
        boldText: 'Reviewing over goals.',
        description: 'Maintaining goals and overcoming barriers.'
      }, {
        hover: 'hover5',
        title: 'Finishing Reboot Kids',
        boldText: 'Congratulations!',
        description: 'You have officially completed Reboot Kids!'
      }]
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Medals, [{
    key: 'calcProgressOfModule',
    value: function calcProgressOfModule() {
      // const moduleData = this.props.app;
      // let key = '';
      // let key2 = '';
      // let totalNum = 0;
      // let numCompleted = 0;

      // const completedModules = [];
      // let index = 0;
      // for (key in this.props.app) {
      //   if (this.props.app.hasOwnProperty(key)) {
      //     totalNum = 0;
      //     numCompleted = 0;
      //     for (key2 in moduleData[key]) {
      //       // get first 3 letters, to know if app or not
      //       if (key2.substring(0, 3) === 'app') {
      //         const tempMod = moduleData[key];
      //         if (tempMod[key2].isCompleted === true) {
      //           numCompleted++;
      //         }
      //         totalNum++;
      //       }
      //     }
      //     if (numCompleted === totalNum) {
      //       completedModules.push(this.state.medals[index]);
      //     }
      //   }
      //   index++;
      // }
      // return completedModules;

      var completedModules = [];
      var key = '';
      var index = 0;
      for (key in this.props.app) {
        if (this.props.app.hasOwnProperty(key)) {
          var temp = this.props.app[key];
          console.log("Key is " + key + " Appcompleted is " + temp.numAppCompleted + " totalapp is " + temp.numAppTotal);
          if (temp.numAppCompleted >= temp.numAppTotal) {
            completedModules.push(this.state.medals[index]);
          }
          // Booster module auto completed because removed, index 4 is Module 4, index 5 was the old Booster Module
          if (completedModules.includes(this.state.medals[4])) {
            completedModules.push(this.state.medals[5]);
          }
        }
        index++;
      }

      return completedModules;
    }
  }, {
    key: 'render',
    value: function render() {
      var medal0 = require('./Assets/medal0.png');
      var medal1 = require('./Assets/medal1.png');
      var medal2 = require('./Assets/medal2.png');
      var medal3 = require('./Assets/medal3.png');
      var medal4 = require('./Assets/medal4.png');
      var medal5 = require('./Assets/medal5.png');
      var styles = require('./Profile.scss');
      var completedModules = this.calcProgressOfModule();

      var allMedals = [medal0, medal1, medal2, medal3, medal4, medal5];

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.card + ' ' + styles.cardContent },
          _react2.default.createElement(
            'h2',
            { className: styles.orangeText + ' ' + styles.textCenter },
            'Medals'
          ),
          _react2.default.createElement(
            'h4',
            null,
            'You\'ll receive a new medal for each module you complete on ',
            _react2.default.createElement(
              'strong',
              { className: styles.orangeText },
              'Reboot Kids!'
            )
          ),
          _react2.default.createElement('div', { className: styles.spacer20 }),
          _react2.default.createElement(
            ReactBootstrap.Row,
            null,
            completedModules.map(function (item, index) {
              return _react2.default.createElement(
                ReactBootstrap.Col,
                { md: 2, sm: 2, xs: 2, key: 'medal' + index },
                _react2.default.createElement(
                  ReactBootstrap.OverlayTrigger,
                  { trigger: ['hover', 'focus'],
                    placement: 'bottom', overlay: popoverHoverFocus(item.hover, item.title, item.boldText, item.description) },
                  _react2.default.createElement(ReactBootstrap.Image, { src: allMedals[index], responsive: true })
                )
              );
            })
          )
        )
      );
    }
  }]);
  return Medals;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  app: _propTypes2.default.object
}, _temp2)) || _class);
exports.default = Medals;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Profile/Medals.js
// module id = 1225
// module chunks = 0